<template>
  <div>
    <div v-if="isLoading" class="loader"></div>
    <div v-if="isLoading" class="loadertext">
      {{ $t("loadingTxt") }}...
    </div>

    <div class="main-wrapper" :class="{ 'blur-content': isLoading }">
      <sidebar-component classMenu="TemplateSetting"></sidebar-component>

      <div class="page-wrapper">
        <navbar-component></navbar-component>

        <div class="page-content">
          <div class="d-flex justify-content-between align-items-center flex-wrap grid-margin">
            <div>
              <button class="btn btn-link px-0 text-decoration-none mb-2" @click="goBack">
                <i class="mdi mdi-arrow-left me-1"></i>
                Back to PI Customer List
              </button>
              <h4 class="mb-0">{{ pageTitle }}</h4>
            </div>
            <div v-show="isEdit">
              <button class="btn btn-twitter btn-sm float-end" @click="recalculate" type="button">
                <i class="mdi mdi-refresh me-1"></i>
                {{ $t("recalculatePi") }}
              </button>
            </div>
          </div>

          <div class="card customer-pi-card">
            <div class="card-body">
              <div class="status-title">Status : {{ statusLabel }}</div>

              <div class="row">
                <div class="col-xl-6 col-lg-7">
                  <div class="row mb-3">
                    <div class="col-sm-4">
                      <label class="col-form-label">Customer</label>
                    </div>
                    <div class="col-sm-8">
                      <input type="text" class="form-control" :value="displayCustomer" disabled />
                    </div>
                  </div>


                  <div class="row mb-3">
                    <div class="col-sm-4">
                      <label class="col-form-label">Template PI</label>
                    </div>
                    <div class="col-sm-8">
                      <multiselect :key="templateSelectKey" ref="templateSelect" v-model="selectedTemplate"
                        :options="templateOptions" track-by="proforma_invoice_template_header_id" label="template_name"
                        placeholder="Pilih template PI" @input="handleTemplateInput" :disabled="isView || isEdit"
                        @open="removeReadonly('templateSelect')" @search-change="searchTemplates">
                        <template slot="option" slot-scope="{ option }">
                          <div class="template-option">
                            <div class="fw-semibold">
                              {{ option.template_name || "-" }}
                            </div>
                            <small class="text-muted">
                              {{ option.description || "Tanpa deskripsi" }}
                            </small>
                          </div>
                        </template>
                        <span slot="noResult">-</span>
                      </multiselect>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-sm-4">
                      <label class="col-form-label">Load Id</label>
                    </div>
                    <div class="col-sm-8">
                      <div class="input-group">
                        <input v-model.trim="form.load_id" type="text" class="form-control"
                          :disabled="isView || isLoadChecked "
                          @input="normalizeLoadIdInput"
                          placeholder="Masukkan load id, pisahkan dengan koma jika lebih dari satu" />
                        <button v-if="!isView && isLoadChecked" type="button"
                          class="btn btn-outline-secondary" @click="resetLoadId">
                          <i class="mdi mdi-lock-reset me-1"></i> Reset Load ID
                        </button>
                        <button v-if="!isView" type="button" class="btn btn-outline-primary"
                          :disabled="isCheckingLoad || isLoadChecked" @click="checkLoadId">
                          {{ isCheckingLoad ? "Checking..." : "Cek Load ID" }}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-sm-4">
                      <label class="col-form-label">Shipment No</label>
                    </div>
                    <div class="col-sm-8">
                      <input v-model.trim="form.shipment_no" type="text" class="form-control" :disabled="isView"
                        @input="normalizeShipmentNoInput"
                        placeholder="Masukkan shipment number, pisahkan dengan koma jika lebih dari satu" />
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-sm-4">
                      <label class="col-form-label">Report Period</label>
                    </div>
                    <div class="col-sm-8">
                      <datepicker
                        v-model="monthPeriodeDate"
                        minimum-view="month"
                        maximum-view="month"
                        initial-view="month"
                        :format="formatMonthPicker"
                        :bootstrap-styling="true"
                        :disabled="isView"
                        placeholder="Pilih Bulan & Tahun"
                        input-class="form-control bg-white"
                      ></datepicker>
                    </div>
                  </div>

                  <!-- Field khusus SAM -->
                  <template v-if="isSam">
                    <div class="row mb-3">
                      <div class="col-sm-4">
                        <label class="col-form-label">PI Rental</label>
                      </div>
                      <div class="col-sm-8">
                        <multiselect
                          v-model="samForm.piRental"
                          :options="piRentalOptions"
                          label="rental_name"
                          track-by="id"
                          placeholder="Pilih PI Rental"
                          :disabled="isView"
                          @search-change="searchPiRental"
                        >
                          <span slot="noResult">-</span>
                        </multiselect>
                      </div>
                    </div>

                    <!-- <div class="row mb-3">
                      <div class="col-sm-4">
                        <label class="col-form-label">Billable Method</label>
                      </div>
                      <div class="col-sm-8">
                        <multiselect
                          v-model="samForm.billableMethod"
                          :options="billableTariffOptions"
                          label="tariff_name"
                          track-by="rm_billable_tariff_id"
                          placeholder="Pilih Billable Method"
                          :disabled="isView"
                          @search-change="searchBillableTariff"
                        >
                          <span slot="noResult">-</span>
                        </multiselect>
                      </div>
                    </div> -->

                    <div class="row mb-3">
                      <div class="col-sm-4">
                        <label class="col-form-label">Date Range</label>
                      </div>
                      <div class="col-sm-8">
                        <date-range-picker
                          style="width: 100%"
                          control-container-class="form-control"
                          :locale-data="dateRangeLocale"
                          v-model="samForm.dateRange"
                          :singleDatePicker="false"
                          :disabled="isView"
                        >
                        </date-range-picker>
                      </div>
                    </div>
                  </template>


                </div>

                <div class="col-xl-6 col-lg-5">
                  <div class="row mb-3">
                    <div class="col-sm-4">
                      <label class="col-form-label">PI Number</label>
                    </div>
                    <div class="col-sm-8">
                      <input type="text" class="form-control" :value="form.pi_no || '-'" disabled />
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-sm-4">
                      <label class="col-form-label">Tipe PI</label>
                    </div>
                    <div class="col-sm-8">
                      <select v-model="form.pi_type" class="form-select" :disabled="isView">
                        <option value="">Pilih tipe PI</option>
                        <option v-for="item in piTypeOptions" :key="item.value" :value="item.value">
                          {{ item.label }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-sm-4">
                      <label class="col-form-label">Branch</label>
                    </div>
                    <div class="col-sm-8">
                      <input type="text" class="form-control" :value="branchName || '-'" disabled />
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-sm-4">
                      <label class="col-form-label">PPN </label>
                    </div>
                    <div class="col-sm-8">
                      <select v-model="selectedPpn" class="form-select" :disabled="isView || !nstRulesOptions.length">
                        <option value="" disabled>Pilih PPN</option>
                        <option v-for="ppn in nstRulesOptions" :key="ppn" :value="ppn">
                          {{ ppn }}
                        </option>
                      </select>
                      <small v-if="!nstRulesOptions.length && !isEdit && !isView" class="text-muted">
                        Cek Load ID terlebih dahulu
                      </small>
                    </div>
                  </div>

                  <!-- <div class="row mb-3">
                    <div class="col-sm-4">
                      <label class="col-form-label">Template Name</label>
                    </div>
                    <div class="col-sm-8">
                      <input type="text" class="form-control" :value="selectedTemplate?.template_name || '-'"
                        disabled />
                    </div>
                  </div> -->
                </div>
              </div>

              <div class="d-flex justify-content-end gap-2 mb-3" v-if="!isView">
                <button type="button" class="btn btn-outline-danger btn-sm" @click="resetForm">
                  <i class="mdi mdi-delete-outline me-1"></i>
                  Reset
                </button>

                <button class="btn btn-success btn-sm" @click="handleAddRows">
                  <i class="mdi mdi-plus me-1"></i>
                  Tambah
                </button>
              </div>

              <!-- Tab Navigation: muncul hanya jika template punya >1 sheet -->
              <div v-if="templateDetails.length > 1" class="pi-tabs-wrapper mb-0">
                <ul class="nav pi-sheet-tabs">
                  <li
                    v-for="(detail, idx) in templateDetails"
                    :key="detail.proforma_invoice_template_detail_id"
                    class="nav-item"
                  >
                    <button
                      class="nav-link"
                      :class="{ active: activeTabIndex === idx }"
                      @click="activeTabIndex = idx"
                      type="button"
                    >
                      {{ detail.detail_name }}
                      <small
                        v-if="detail.detail_alias"
                        class="d-block tab-alias"
                      >{{ detail.detail_alias }}</small>
                    </button>
                  </li>
                </ul>
              </div>

              <vue-good-table
                :key="tableRenderKey + '_tab_' + activeTabIndex"
                ref="detailTable"
                :columns="tableColumns"
                :rows="activeRows"
                :line-numbers="true"
                :select-options="{
                  enabled: true,
                  selectOnCheckboxOnly: true,
                  selectionText: $t('data_selected'),
                  clearSelectionText: $t('clear'),
                }"
                :pagination-options="{ enabled: false }"
                :sort-options="{ enabled: false }"
                styleClass="vgt-table striped bordered"
                @on-selected-rows-change="onSelectionChanged"
                :row-style-class="getRowClass"
              >
                <div slot="table-actions">
                  {{ $t("no_select_data") }}
                </div>
                <div slot="selected-row-actions">
                  <button class="btn btn-danger btn-xs" @click="handleDeleteRows" v-if="!isView">
                    <i class="mdi mdi-close"></i> Hapus
                  </button>
                </div>

                <template slot="table-row" slot-scope="props">
                  <span v-if="isCurrencyField(props.column.field)"
                    :class="{ 'amn-total-value': props.row._isGroupTotal }">
                    {{ formatNumber(props.row[props.column.field]) }}
                  </span>
                  <span v-else
                    :class="{ 'amn-total-value': props.row._isGroupTotal }">
                    {{ formatCell(props.row[props.column.field]) }}
                  </span>



                </template>
              </vue-good-table>

              <div class="row justify-content-end mt-4">
                <div class="col-lg-4 col-md-6">
                  <div class="summary-card">
                    <div class="summary-row">
                      <span>Rate</span>
                      <input type="text" class="form-control form-control-sm" :value="formatNumber(summaryRate)"
                        disabled />
                    </div>

                    <div class="summary-row">
                      <span>Total Charge</span>
                      <input type="text" class="form-control form-control-sm" :value="formatNumber(summaryTotalCharge)"
                        disabled />
                    </div>
                    <hr>
                    <div class="summary-row">
                      <span>Total</span>
                      <input type="text" class="form-control form-control-sm" :value="formatNumber(summaryRate_charge)"
                        disabled />
                    </div>

                    <div class="summary-row">
                      <span>Dpp</span>
                      <input type="text" class="form-control form-control-sm" :value="formatNumber(summaryDpp)"
                        disabled />
                    </div>
                    <div class="summary-row">
                      <span>Ppn</span>
                      <input type="text" class="form-control form-control-sm" :value="formatNumber(summaryPpn)"
                        disabled />
                    </div>
                    <hr>
                    <div class="summary-row mb-0">
                      <span>Grand Total</span>
                      <input type="text" class="form-control form-control-sm" :value="formatNumber(summaryGrandTotal)"
                        disabled />
                    </div>

                    <div class="d-flex justify-content-end mt-3" v-if="!isView">
                      <button class="btn btn-info btn-sm text-white" :disabled="!canSubmit" @click="submitForm">
                        Kirim Data
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <footer-component></footer-component>
      </div>
    </div>
  </div>
</template>

<script>
import multiselect from "vue-multiselect";
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import Datepicker from "vuejs-datepicker";


const CURRENCY_FIELDS = new Set([
  "rate",
  "dpp",
  "ppn",
  "total_rate",
  "veh_cost",
  "tonnage_cost",
  "exs_tonnage_cost",
  "multi_cost",
  "total_cost",
  "billable_rate",
  "AAJ",
  "CUS4", "DRO", "EXP", "INS", "OPC", "5D", "OAC",
  "PRK", "PUD", "PUC", "RET", "STD", "SRG", "charge_740", "URC",
  "FLC", "HAZ", "SAT", "other_charge",
]);

const CHARGE_FIELDS = [
  "AAJ", "CUS4", "DRO", "EXP", "INS", "OPC", "5D", "OAC",
  "PRK", "PUD", "PUC", "RET", "STD", "SRG", "charge_740", "URC",
  "FLC", "HAZ", "SAT", "other_charge",
];

function buildEmptyForm() {
  return {
    load_id: "",
    shipment_no: "",
    pi_type: "",
    pi_no: "",
    proforma_invoice_template_header_id: "",
    proforma_invoice_header_id: "",
    month_periode: "",
  };
}

export default {
  name: "CustomerListInvoiceForm",
  components: {
    multiselect,
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    "date-range-picker": DateRangePicker,
    Datepicker,
  },
  data() {
    return {
      isLoading: false,
      permision_role: {
        method_create: true,
        method_read: true,
        method_update: true,
        method_delete: true,
      },
      customer: {
        company_code: this.$route.params.id || "",
        customer_name: this.$route.query.name || this.$route.params.id || "",
        sap_code: this.$route.query.sap_code || "",
      },
      monthPeriodeDate: null,
      form: buildEmptyForm(),
      templateOptions: [],
      selectedTemplate: null,
      templateSelectKey: 0,
      templateFields: [],
      templateDetails: [],   // raw array detail sheet dari response template (untuk tabs)
      activeTabIndex: 0,     // index tab yang sedang aktif
      piTypeOptions: [],
      nstRulesOptions: [],
      selectedPpn: null,
      // SAM-specific form fields
      samForm: {
        piRental: null,
        billableMethod: null,
        dateRange: {
          startDate: null,
          endDate: null,
        },
      },
      piRentalOptions: [],
      billableTariffOptions: [],
      dateRangeLocale: {
        format: "yyyy-mm-dd",
      },
      rows: [],
      selectedRows: [],
      tableRenderKey: 0,
      companyGetLoad: null,
      checkedLoadId: "",
      isCheckingLoad: false,
      isLoadChecked: false,
      headerDpp: 0,
      headerPpn: 0,
      headerRate: 0,
      headerTotalRate: 0,
      headerTotalCharge: 0,
      initialRowsCount: 0,
      // Flag: apakah API Edit mengembalikan field charge per baris (AAJ, CUS4, dll)
      // Dicek sekali saat loadEditData, digunakan oleh summaryTotalCharge
      hasRowChargeData: false,
    };
  },
  watch: {
    "form.load_id"(newValue) {
      if (String(newValue || "") === String(this.checkedLoadId || "")) {
        return;
      }

      this.companyGetLoad = null;
      this.nstRulesOptions = [];
      this.selectedPpn = null;
    },
  },
  computed: {
    isEdit() {
      return Boolean(this.$route.params.piNo) && this.$route.name !== "CustomerListInvoiceView";
    },
    isView() {
      return this.$route.name === "CustomerListInvoiceView";
    },
    isLoadEditable() {
      // Di mode edit, load id hanya bisa diedit setelah klik Reset Load ID
      return !this.isLoadChecked;
    },
    pageTitle() {
      if (this.isView) return "View - PI Non STD";
      return this.isEdit ? "Edit - PI Non STD" : "Create - PI Non STD";
    },
    statusLabel() {
      return "CREATED";
    },
    displayCustomer() {
      const code = this.customer.company_code || "-";
      const name = this.customer.customer_name || "-";
      return `${code} - ${name}`;
    },
    proformaInvoiceEndpoint() {
      return String(this.$settings?.endPointProformaInvoice || "").replace(/\/?$/, "/");
    },
    branchName() {
      return (
        this.companyGetLoad?.company_setting?.branch?.branch_name ||
        this.rows[0]?.branch ||
        ""
      );
    },
    tableColumns() {
      // Jika tidak ada template → kolom default
      if (!this.templateDetails.length) {
        return [
          { label: "Load ID", field: "load_id" },
          { label: "Shipment No", field: "shipment_no" },
          { label: "Rate", field: "rate" },
        ];
      }

      // Kolom dari tab yang sedang aktif
      const activeDetail = this.templateDetails[this.activeTabIndex];
      if (!activeDetail) return [];

      const fields = [...(activeDetail.detail_field || [])].sort(
        (a, b) => (a.field_order || 0) - (b.field_order || 0)
      );

      return fields.map((f) => ({
        label:
          f.field_alias ||
          f.field?.field_lable ||
          f.field?.field_code ||
          "-",
        field: f.field?.field_code || f.field_code || "",
        sortable: false,
      }));
    },
    // Rows tab aktif — filter berdasarkan _sheetDetailId.
    // Rows tanpa tag (_sheetDetailId null/undefined) → masuk tab pertama sebagai fallback.
    activeRows() {
      if (!this.templateDetails.length) return this.rows;
      const activeDetail = this.templateDetails[this.activeTabIndex];
      if (!activeDetail) return this.rows;
      const detailId = activeDetail.proforma_invoice_template_detail_id;
      return this.rows.filter((r) => {
        const itemSheetId =
          r._sheetDetailId != null
            ? r._sheetDetailId
            : r.proforma_invoice_template_detail_id;
        if (itemSheetId == null) {
          // Rows lama / tidak ber-tag → masuk tab pertama
          return this.activeTabIndex === 0;
        }
        return String(itemSheetId) === String(detailId);
      });
    },
    rowsRatio() {
      // Rasio baris tab aktif vs total baris awal (proporsional untuk edit/view)
      if (this.initialRowsCount <= 0) return 1;
      if (this.rows.length === 0) return 0;
      return this.activeRows.length / this.initialRowsCount;
    },
    summaryRate() {
      // Hitung dari rows tab aktif saja
      if (this.activeRows.length > 0) {
        return this.activeRows.reduce((sum, item) => {
          // Baris detail dalam group SPLIT ORDER (AMN) → skip, sudah diwakili baris Total
          if (item._isPartOfSplitGroup) return sum;
          return sum + Number(item.rate || 0);
        }, 0);
      }
      return 0;
    },
    summaryTotalCharge() {
      // Hitung dari rows tab aktif saja
      if (this.activeRows.length === 0) return 0;

      // Mode Create: hitung langsung dari field charge per baris
      if (!this.isEdit && !this.isView) {
        return this.activeRows.reduce((sum, item) => {
          return sum + CHARGE_FIELDS.reduce((s, field) => s + Number(item[field] || 0), 0);
        }, 0);
      }

      // Mode Edit/View: jika API mengembalikan field charge per baris
      if (this.hasRowChargeData) {
        return this.activeRows.reduce((sum, item) => {
          return sum + CHARGE_FIELDS.reduce((s, field) => s + Number(item[field] || 0), 0);
        }, 0);
      }

      // Fallback proporsional
      return this.headerTotalCharge * this.rowsRatio;
    },
    summaryRate_charge() {
      return this.summaryRate + this.summaryTotalCharge;
    },
    summaryDpp() {
      if (this.isEdit || this.isView) {
        // Hitung proporsional berdasarkan baris yang tersisa
        return this.headerDpp * this.rowsRatio;
      }
      const autoDpp = this.companyGetLoad?.company_setting?.auto_dpp === "Y";
      return autoDpp ? this.summaryRate_charge * 11 / 12 : 0;
    },
    summaryPpn() {
      if (this.isEdit || this.isView) {
        // Hitung proporsional berdasarkan baris yang tersisa
        return this.headerPpn * this.rowsRatio;
      }
      if (!this.selectedPpn) return 0;

      const label = String(this.selectedPpn).toUpperCase();
      let percentage = 0;

      if (label.includes("PPN 10")) {
        percentage = 0.1;
      } else if (label.includes("PPN 11")) {
        percentage = 0.11;
      } else if (label.includes("PPN 1.1")) {
        percentage = 0.011;
      } else if (label.includes("PPN 12")) {
        percentage = 0.12;
      } else if (label.includes("PPN 2.5") || label.includes("PPH 2.5")) {
        percentage = 0.025;
      }

      return this.summaryDpp * percentage;
    },
    summaryGrandTotal() {
      return this.summaryRate_charge + this.summaryPpn;
    },
    canSubmit() {
      return Boolean(
        this.form.pi_type &&
        this.form.proforma_invoice_template_header_id &&
        this.rows.length
      );
    },
    isAmn() {
      return String(this.customer.company_code || '').trim().toUpperCase() === 'AMN';
    },
    isSWT() {
      const code = String(this.customer.company_code || '').trim().toUpperCase();
      return code === 'SWT' || code === 'KMI';
    },
    isSam() {
      return String(this.customer.company_code || '').trim().toUpperCase() === 'SAM';
    },
  },
  methods: {
    normalizeLoadIdInput(event) {
      const raw = String(event?.target?.value || "");
      this.form.load_id = raw
        .replace(/\s+/g, ",")   // spasi/newline/tab → koma
        .replace(/,+/g, ",")    // koma duplikat → satu koma
        .replace(/^,/, "");     // trim koma di awal
    },
    normalizeShipmentNoInput(event) {
      this.form.shipment_no = String(event?.target?.value || "").replace(/\s+/g, ",");
    },
    parseMonthPeriodeToDate(val) {
      if (!val) return null;
      if (val instanceof Date) return val;
      const str = String(val).trim();
      const MONTH_NAMES_ID = [
        "Januari", "Februari", "Maret", "April", "Mei", "Juni",
        "Juli", "Agustus", "September", "Oktober", "November", "Desember"
      ];

      const textMatch = str.match(/^([a-zA-Z]+)\s+(\d{4})$/);
      if (textMatch) {
        const monthName = textMatch[1].toLowerCase();
        const year = parseInt(textMatch[2], 10);
        const monthIdx = MONTH_NAMES_ID.findIndex((m) => m.toLowerCase() === monthName);
        if (monthIdx !== -1 && !isNaN(year)) {
          return new Date(year, monthIdx, 1);
        }
      }

      const numMatch = str.match(/^(\d{1,2})[/-]?(\d{4})$/);
      if (numMatch) {
        const monthNum = parseInt(numMatch[1], 10);
        const year = parseInt(numMatch[2], 10);
        if (monthNum >= 1 && monthNum <= 12 && !isNaN(year)) {
          return new Date(year, monthNum - 1, 1);
        }
      }

      const d = new Date(str);
      return isNaN(d.getTime()) ? null : d;
    },
    formatDateToIndonesianMonth(date) {
      if (!date) return null;
      const d = date instanceof Date ? date : new Date(date);
      if (isNaN(d.getTime())) return null;
      const MONTH_NAMES_ID = [
        "Januari", "Februari", "Maret", "April", "Mei", "Juni",
        "Juli", "Agustus", "September", "Oktober", "November", "Desember"
      ];
      return `${MONTH_NAMES_ID[d.getMonth()]} ${d.getFullYear()}`;
    },
    formatMonthPicker(date) {
      return this.formatDateToIndonesianMonth(date) || "";
    },
    async initializePage() {
      await this.loadCustomerInfo();
      await Promise.all([this.loadPiTypes(), this.loadTemplateOptions()]);

      if (this.isSam) {
        await Promise.all([this.loadBillableTariff(), this.loadPiRental()]);
      }

      if (this.isEdit || this.isView) {
        await this.loadEditData();
      }
    },
    async loadCustomerInfo() {
      if (this.customer.customer_name && this.customer.sap_code) {
        return;
      }

      try {
        const response = await this.$http.get(
          `${this.proformaInvoiceEndpoint}v1/company-list/index`,
          {
            params: {
              company_code: this.$route.params.id,
              page: 1,
              limit: 1,
            },
          }
        );
        const company = response.data?.datas?.data?.[0];

        if (company) {
          this.customer = {
            company_code: company.code || this.$route.params.id || "",
            customer_name: company.name || this.$route.params.id || "",
            sap_code: company.sap_code || "",
          };
        }
      } catch (error) {
        this.handleRequestError(error, "Gagal load customer info.");
      }
    },
    async loadTemplateOptions(search = "") {
      try {
        const response = await this.$http.get(
          `${this.proformaInvoiceEndpoint}v1/template-pi/index`,
          {
            params: {
              company_name: this.customer.customer_name || "",
              template_name: search || undefined,
              limit: 50,
              page: 1,
            },
          }
        );

        const rows = Array.isArray(response.data?.datas?.data)
          ? response.data.datas.data
          : Array.isArray(response.data?.datas)
            ? response.data.datas
            : [];

        const currentTemplate = this.selectedTemplate
          ? [this.selectedTemplate]
          : [];
        const merged = [...rows, ...currentTemplate];
        const seen = new Set();

        this.templateOptions = merged.filter((item) => {
          const id = String(item?.proforma_invoice_template_header_id || "");

          if (!id || seen.has(id)) {
            return false;
          }

          seen.add(id);
          return true;
        });
      } catch (error) {
        this.handleRequestError(error, "Gagal load template PI.");
      }
    },
    searchTemplates(query) {
      this.loadTemplateOptions(query);
    },
    async loadPiTypes() {
      try {
        const response = await this.$http.get(
          `${this.$settings.endPointCt}master-lookup?unique_id=pitype`
        );
        const rawItems = Array.isArray(response.data?.datas)
          ? response.data.datas
          : Array.isArray(response.data?.datas?.data)
            ? response.data.datas.data
            : [];

        this.piTypeOptions = rawItems
          .map((item) => {
            const value =
              item?.code ||
              item?.dependent ||
              item?.value ||
              item?.lookup_value ||
              item;

            if (!value) {
              return null;
            }

            return {
              value: String(value),
              label:
                item?.dependent_name ||
                item?.description ||
                item?.name ||
                String(value),
            };
          })
          .filter(Boolean);
      } catch (error) {
        this.handleRequestError(error, "Gagal load tipe PI.");
      }
    },
    removeReadonly(refName) {
      this.$nextTick(() => {
        const input = this.$refs[refName]?.$el?.querySelector(".multiselect__input");

        if (input?.hasAttribute("readonly")) {
          input.removeAttribute("readonly");
        }
      });
    },
    humanizeFieldCode(value) {
      return String(value || "")
        .split("_")
        .filter(Boolean)
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join(" ");
    },
    // Mengambil ppn_array dari response get-load dan set ke nstRulesOptions.
    // ppn_array berupa array string: ["PPN 10", "PPN 11", "PPN 1.1", "PPN 12", "PPN 2.5"]
    setPpnArrayOptions(ppnArray) {
      console.log(ppnArray);
      const previousSelected = this.selectedPpn;
      this.nstRulesOptions = Array.isArray(ppnArray) ? [...ppnArray] : [];

      if (this.nstRulesOptions.length === 1) {
        // Auto-select jika hanya ada 1 opsi
        this.selectedPpn = this.nstRulesOptions[0];
        return;
      }

      // Pertahankan pilihan sebelumnya jika masih ada di opsi baru
      if (previousSelected && this.nstRulesOptions.includes(previousSelected)) {
        this.selectedPpn = previousSelected;
      } else {
        this.selectedPpn = null;
      }
    },
    normalizeTemplateFields(detailList) {
      const rows = [];

      (detailList || []).forEach((detail) => {
        (detail?.detail_field || []).forEach((field) => {
          const fieldCode = field?.field?.field_code || field?.field_code;

          if (!fieldCode) {
            return;
          }

          rows.push({
            id:
              field?.proforma_invoice_template_detail_fields_id ||
              `${detail?.detail_order || 0}-${field?.field_order || 0}-${fieldCode}`,
            field_code: fieldCode,
            field_alias:
              field?.field_alias ||
              field?.field?.field_lable ||
              this.humanizeFieldCode(fieldCode),
            detail_order: Number(detail?.detail_order || 0),
            field_order: Number(field?.field_order || 0),
          });
        });
      });

      rows.sort((left, right) => {
        if (left.detail_order !== right.detail_order) {
          return left.detail_order - right.detail_order;
        }

        return left.field_order - right.field_order;
      });

      const seen = new Set();

      return rows.filter((item) => {
        if (seen.has(item.field_code)) {
          return false;
        }

        seen.add(item.field_code);
        return true;
      });
    },
    async loadTemplateDetail(templateId) {
      if (!templateId) {
        this.templateFields = [];
        this.templateDetails = [];
        this.activeTabIndex = 0;
        return;
      }

      try {
        const response = await this.$http.get(
          `${this.proformaInvoiceEndpoint}v1/template-pi/detail/${templateId}`
        );
        const datas = response.data?.datas || {};

        // Simpan raw detail per-sheet (untuk tabs), urutkan by detail_order
        this.templateDetails = [...(datas.detail || [])].sort(
          (a, b) => (a.detail_order || 0) - (b.detail_order || 0)
        );
        this.activeTabIndex = 0;

        // Flatten fields (tetap dipertahankan untuk normalizeTemplateFields lain)
        this.templateFields = this.normalizeTemplateFields(datas.detail || []);

        if (!this.selectedTemplate && datas.proforma_invoice_template_header_id) {
          this.selectedTemplate = {
            proforma_invoice_template_header_id:
              datas.proforma_invoice_template_header_id,
            template_name: datas.template_name || "-",
            description: datas.description || "",
          };
        }
      } catch (error) {
        this.handleRequestError(error, "Gagal load detail template PI.");
      }
    },
    async handleTemplateInput(template) {
      const previousTemplateId = this.form.proforma_invoice_template_header_id;
      const previousTemplate = this.templateOptions.find(
        (item) =>
          String(item.proforma_invoice_template_header_id) ===
          String(previousTemplateId)
      ) || null;
      const nextTemplateId = template?.proforma_invoice_template_header_id
        ? String(template.proforma_invoice_template_header_id)
        : "";

      if (
        this.rows.length &&
        previousTemplateId &&
        previousTemplateId !== nextTemplateId
      ) {
        const result = await this.$swal({
          title: "Ganti Template PI?",
          text: "Perubahan template akan mengosongkan detail shipment yang sudah ditambahkan.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya, ganti",
          cancelButtonText: "Batal",
        });

        if (!result.value) {
          this.$nextTick(() => {
            this.selectedTemplate = previousTemplate;
          });
          return;
        }

        this.rows = [];
        this.selectedRows = [];
        this.activeTabIndex = 0; // reset ke tab pertama saat template diganti
        // Reset summary fields ketika template diganti dan rows dikosongkan
        this.companyGetLoad = null;
        this.nstRulesOptions = [];
        this.selectedPpn = null;
      }

      this.form.proforma_invoice_template_header_id = nextTemplateId;

      if (!nextTemplateId) {
        this.templateFields = [];
        return;
      }

      await this.loadTemplateDetail(nextTemplateId);
    },
    async fetchCompanyLoad(loadId = this.form.load_id) {
      try {
        const response = await this.$http.get(
          `${this.proformaInvoiceEndpoint}v1/company-list/get-load`,
          {
            params: {
              company_code: this.customer.company_code,
              load_id: loadId,
              proforma_invoice_template_header_id: this.form.proforma_invoice_template_header_id
            },
          }
        );

        this.companyGetLoad = response.data?.datas || null;

        // ppn_array adalah array string dari backend, contoh: ["PPN 10", "PPN 11"]
        const ppnArray = this.companyGetLoad?.ppn_array || [];
        this.setPpnArrayOptions(ppnArray);

        this.checkedLoadId = loadId;
        const loadDetails = this.companyGetLoad?.load_detail || [];

        const requestedLoadIds = [
          ...new Set(
            String(loadId || "")
              .split(",")
              .map((id) => id.trim())
              .filter(Boolean)
          ),
        ];

        if (requestedLoadIds.length > 0) {
          const foundLoadIds = new Set(
            loadDetails
              .map((item) => String(item?.load_id ?? "").trim())
              .filter(Boolean)
          );

          const missingLoadIds = requestedLoadIds.filter(
            (id) => !foundLoadIds.has(id)
          );

          if (missingLoadIds.length > 0) {
            await this.$swal({
              icon: "warning",
              title: "Informasi Load ID",
              text: `Load ID ${missingLoadIds.join(", ")} sudah pernah dibuat.`,
              confirmButtonText: "Baik",
            });
          }
        }

        return loadDetails;
      } catch (error) {
        this.companyGetLoad = null;
        this.nstRulesOptions = [];
        this.selectedPpn = null;
        this.checkedLoadId = "";
        this.handleRequestError(error, "Gagal mengecek load id.");
        return [];
      }
    },
    async checkLoadId() {
      if (this.form.load_id) {
        this.form.load_id = String(this.form.load_id).replace(/^,|,$/g, "");
      }
      if (!this.form.load_id) {
        await this.$swal({
          icon: "warning",
          title: "Load Id wajib diisi",
          text: "Masukkan load id terlebih dahulu sebelum melakukan pengecekan.",
          confirmButtonText: "Baik",
        });
        return;
      }

      this.isCheckingLoad = true;

      try {
        const loadDetails = await this.fetchCompanyLoad(this.form.load_id);

        if (loadDetails.length) {
          this.success("Load id berhasil ditemukan.");
          this.isLoadChecked = true;
        }
      } finally {
        this.isCheckingLoad = false;
      }
    },
    resetLoadId() {
      this.isLoadChecked = false;
      this.companyGetLoad = null;
      this.nstRulesOptions = [];
      this.selectedPpn = null;
      this.checkedLoadId = "";
      this.form.load_id = "";
    },
    async fetchShipments() {
      try {
        const response = await this.$http.get(
          `${this.proformaInvoiceEndpoint}v1/company-list/get-shipment`,
          {
            params: {
              company_code: this.customer.company_code,
              shipment_no: this.form.shipment_no,
              load_id:this.checkedLoadId
            },
          }
        );

        return Array.isArray(response.data?.datas) ? response.data.datas : [];
      } catch (error) {
        //this.handleRequestError(error, "Gagal load shipment.");
        return [];
      }
    },
    buildRowKey(item) {
      return [
        item.row_type || "SHIPMENT",
        item.order_no,
        item.shipment_no,
        item.material_id || "",
        item.unique_index || ""
      ].join("|");
    },
    mergeShipmentRows(shipments) {
      const primaryLoad = this.companyGetLoad?.load_detail?.[0] || {};
      const branchName =
        this.companyGetLoad?.company_setting?.branch?.branch_name || "";
      const templateName = this.selectedTemplate?.template_name || "";

      return (shipments || []).map((item) => ({
        ...item,
        customer_id: this.customer.company_code,
        customer_name: this.customer.customer_name,
        pi_type: this.form.pi_type || "",
        pi_no: this.form.pi_no || "",
        load_id: primaryLoad.load_id ?? item.load_id ?? null,
        order_no: item.order_no || "",
        shipment_no: item.shipment_no || "",
        order_date: item.order_date || "",
        rate: Number(item.rate || 0),
        branch: branchName,
        template_name: templateName,
      }));

    },


    mergeGetLoadRows(shipments) {
      // ambil shipment pertama
      const firstShipment = shipments?.[0] || {};

      const branchName =
        this.companyGetLoad?.company_setting?.branch?.branch_name || "";

      const templateName =
        this.selectedTemplate?.template_name || "";

      return (this.companyGetLoad?.load_detail || []).map((item, index) => {

        // clone data load detail
        const mergedItem = {
          ...item,
        };

        // ambil field shipment pertama
        Object.keys(firstShipment).forEach((key) => {

          // skip field tertentu
          if (key === "pi_file_batch") return;

          // jika field belum ada di load detail
          if (
            mergedItem[key] === undefined ||
            mergedItem[key] === null ||
            mergedItem[key] === ""
          ) {
            mergedItem[key] = firstShipment[key];
          }
        });

        // overwrite/custom field
        mergedItem.customer_id =
          this.customer.company_code || item.customer_id;

        mergedItem.customer_name =
          this.customer.customer_name || item.customer_name;

        mergedItem.pi_type = this.form.pi_type || "";

        mergedItem.pi_no = this.form.pi_no || "";

        mergedItem.load_id = item.load_id ?? null;

        mergedItem.rate = Number(mergedItem.rate || 0);

        mergedItem.branch = branchName;

        mergedItem.template_name = templateName;

        // penanda agar key tidak bentrok
        mergedItem.row_type = "GETLOAD";

        mergedItem.unique_index = index;

        return mergedItem;
      });
    },

    buildAmnRows(loadDetails) {
      // Kelompokkan baris berdasarkan load_id, pertahankan urutan kemunculan
      const groups = {};
      const groupOrder = [];

      (loadDetails || []).forEach((item) => {
        const key = String(item.load_id);
        if (!groups[key]) {
          groups[key] = [];
          groupOrder.push(key);
        }
        groups[key].push(item);
      });

      const result = [];

      groupOrder.forEach((loadKey) => {
        const group = groups[loadKey];
        const hasSplitOrder = group.some(
          (item) => String(item.shipment_type || '').toUpperCase() === 'SPLIT ORDER'
        );

        if (hasSplitOrder) {
          // Tampilkan semua baris detail (rate tetap 0 dari API)
          // + tambahkan 1 baris Total di bawah group
          group.forEach((item) => {
            result.push({
              ...item,
              remarks: item.remarks === 'Total' ? '' : (item.remarks || ''),
              _isGroupTotal: false,
              _isPartOfSplitGroup: true,  // skip dari summaryRate
            });
          });

          // Hitung baris Total
          const firstRow = group[0];
          const ratePerMt = parseFloat(firstRow?.rate_per_mt || 0);
          const totalTonnage = group.reduce((s, r) => s + Number(r.tonnage || 0), 0);
          const computedRate = totalTonnage * ratePerMt;
          const sumCpkg = group.reduce((s, r) => s + Number(r.total_rate_cpkg || 0), 0);

          result.push({
            ...firstRow,
            order_no: '',
            shipment_no: '',
            shipment_type: 'TOTAL',
            remarks: 'Total',
            branch: '',
            tonnage: totalTonnage,
            total_tonnage: totalTonnage,
            rate_per_mt: ratePerMt,
            rate: computedRate,
            total_rate_cpkg: sumCpkg,
            _isGroupTotal: true,
            _isPartOfSplitGroup: false,
          });
        } else {
          // Tidak ada SPLIT ORDER → hitung rate langsung per baris
          group.forEach((item) => {
            const ratePerMt = parseFloat(item.rate_per_mt || 0);
            const computedRate = Number(item.tonnage || 0) * ratePerMt;
            result.push({
              ...item,
              remarks: item.remarks === 'Total' ? '' : (item.remarks || ''),
              rate: computedRate,
              _isGroupTotal: false,
              _isPartOfSplitGroup: false,
            });
          });
        }
      });

      return result;
    },

    // Versi reconstruct untuk mode Edit/View (dari response get-detail-pi).
    // BE tidak menyimpan baris Total — baris Total hanya ada di FE.
    // Oleh karena itu, Total di-generate ulang secara dinamis dari kalkulasi,
    // sama seperti buildAmnRows di mode Create:
    //   - Jika load_id memiliki lebih dari 1 baris → SPLIT ORDER → generate baris Total
    //   - Jika load_id hanya 1 baris → standalone → hitung rate = tonnage × rate_per_mt
    buildAmnRowsFromSaved(detailRows) {
      // Kelompokkan baris berdasarkan load_id, pertahankan urutan kemunculan
      const groups = {};
      const groupOrder = [];

      (detailRows || []).forEach((item) => {
        const key = String(item.load_id);
        if (!groups[key]) {
          groups[key] = [];
          groupOrder.push(key);
        }
        groups[key].push(item);
      });

      const result = [];

      groupOrder.forEach((loadKey) => {
        const group = groups[loadKey];

        // Lebih dari 1 baris dalam satu load_id → perlakukan sebagai SPLIT ORDER
        const hasSplitOrder = group.length > 1;

        if (hasSplitOrder) {
          // Tampilkan semua baris detail dengan rate = 0 (sudah diwakili oleh baris Total)
          group.forEach((item) => {
            result.push({
              ...item,
              remarks: item.remarks === 'Total' ? '' : (item.remarks || ''),
              rate: 0,
              _isGroupTotal: false,
              _isPartOfSplitGroup: true,
            });
          });

          // Generate baris Total dari kalkulasi
          const firstRow = group[0];
          const ratePerMt = parseFloat(firstRow?.rate_per_mt || 0);
          const totalTonnage = group.reduce((s, r) => s + Number(r.tonnage || 0), 0);
          const computedRate = totalTonnage * ratePerMt;
          const sumCpkg = group.reduce((s, r) => s + Number(r.total_rate_cpkg || 0), 0);

          result.push({
            ...firstRow,
            order_no: '',
            shipment_no: '',
            shipment_type: 'TOTAL',
            remarks: 'Total',
            branch: '',
            tonnage: totalTonnage,
            total_tonnage: totalTonnage,
            rate_per_mt: ratePerMt,
            rate: computedRate,
            total_rate_cpkg: sumCpkg,
            _isGroupTotal: true,
            _isPartOfSplitGroup: false,
          });
        } else {
          // Standalone: hitung rate = tonnage × rate_per_mt per baris
          group.forEach((item) => {
            const ratePerMt = parseFloat(item.rate_per_mt || 0);
            const computedRate = Number(item.tonnage || 0) * ratePerMt;
            result.push({
              ...item,
              remarks: item.remarks === 'Total' ? '' : (item.remarks || ''),
              rate: computedRate,
              _isGroupTotal: false,
              _isPartOfSplitGroup: false,
            });
          });
        }
      });

      return result;
    },
    async handleAddRows() {
      if (!this.form.load_id) {
        this.error("Load Id wajib diisi.");
        return;
      }

    
      if (!this.form.pi_type) {
        this.error("Tipe PI wajib dipilih.");
        return;
      }

      if (!this.form.proforma_invoice_template_header_id) {
        this.error("Template PI wajib dipilih.");
        return;
      }

      this.isLoading = true;

      try {
        // Logika khusus SWT & KMI: customer_name dan customer_id diambil dari masing-masing item load_detail
        if (this.isSWT) {
          const rawDetails = this.companyGetLoad?.load_detail || [];
          const branchName = this.companyGetLoad?.company_setting?.branch?.branch_name || '';
          const templateName = this.selectedTemplate?.template_name || '';

          let duplicateCount = 0;

          rawDetails.forEach((item, index) => {
            const isDuplicate = this.activeRows.some(
              (existing) =>
                String(existing.load_id) === String(item.load_id) &&
                existing.shipment_no === item.shipment_no &&
                String(existing.material_code || '') === String(item.material_code || '')
            );

            if (isDuplicate) {
              duplicateCount += 1;
              return;
            }

            this.rows.push({
              ...item,
              // Tiap baris pakai customer_id & customer_name dari item load_detail masing-masing
              customer_id: item.customer_id,
              customer_name: item.customer_name || this.customer.customer_name,
              pi_type: this.form.pi_type || '',
              pi_no: this.form.pi_no || '',
              branch: branchName,
              template_name: templateName,
              _sheetDetailId: this.templateDetails[this.activeTabIndex]
                ?.proforma_invoice_template_detail_id ?? null,
              _uniqueId: `swt_${index}_${Date.now()}_${Math.random()}`,
            });
          });

          if (duplicateCount > 0) {
            this.error(`${duplicateCount} baris duplikat dilewati.`);
          }
          return;
        }

        // Logika khusus AMN: gunakan buildAmnRows dari load_detail
        if (this.isAmn) {
          const rawDetails = this.companyGetLoad?.load_detail || [];
          const branchName = this.companyGetLoad?.company_setting?.branch?.branch_name || '';
          const templateName = this.selectedTemplate?.template_name || '';
          const amnRows = this.buildAmnRows(rawDetails);
          let duplicateCount = 0;

          amnRows.forEach((item, index) => {
            const isDuplicate = this.activeRows.some((existing) => {
              if (item._isGroupTotal) {
                return existing._isGroupTotal && String(existing.load_id) === String(item.load_id);
              }
              return !existing._isGroupTotal &&
                String(existing.load_id) === String(item.load_id) &&
                existing.shipment_no === item.shipment_no &&
                String(existing.material_id || '') === String(item.material_id || '');
            });

            if (isDuplicate) {
              duplicateCount += 1;
              return;
            }

            this.rows.push({
              ...item,
              customer_id: this.customer.company_code,
              customer_name: this.customer.customer_name,
              pi_type: this.form.pi_type || '',
              pi_no: this.form.pi_no || '',
              branch: branchName,
              template_name: templateName,
              _sheetDetailId: this.templateDetails[this.activeTabIndex]
                ?.proforma_invoice_template_detail_id ?? null,
              _uniqueId: `amn_${index}_${Date.now()}_${Math.random()}`,
            });
          });

          if (duplicateCount > 0) {
            this.error(`${duplicateCount} baris duplikat dilewati.`);
          }
          return;
        }

        const shipments = await this.fetchShipments();

        const isAdm = String(this.customer.company_code || "").trim().toUpperCase() === "ADM";
        const newRows = this.mergeShipmentRows(shipments);
        const existingKeys = new Set(this.activeRows.map((item) => this.buildRowKey(item)));
        let duplicateCount = 0;

        newRows.forEach((item) => {
          const rowKey = this.buildRowKey(item);

          if (!isAdm && existingKeys.has(rowKey)) {
            duplicateCount += 1;
            return;
          }

          existingKeys.add(rowKey);
          this.rows.push({
            ...item,
            _sheetDetailId: this.templateDetails[this.activeTabIndex]
              ?.proforma_invoice_template_detail_id ?? null,
            _uniqueId: `create_shipment_${existingKeys.size}_${Date.now()}_${Math.random()}`
          });
        });

        const newRowsGetLoad = this.mergeGetLoadRows(shipments);
        const existingKeysRowGetLoad = new Set(
          this.activeRows
            .filter((item) => item.row_type === "GETLOAD")
            .map((item) => this.buildRowKey(item))
        );

        newRowsGetLoad.forEach((item) => {
          const rowKey = this.buildRowKey(item);

          if (!isAdm && existingKeysRowGetLoad.has(rowKey)) {
            duplicateCount += 1;
            return;
          }

          existingKeysRowGetLoad.add(rowKey);
          this.rows.push({
            ...item,
            _sheetDetailId: this.templateDetails[this.activeTabIndex]
              ?.proforma_invoice_template_detail_id ?? null,
            _uniqueId: `create_load_${existingKeysRowGetLoad.size}_${Date.now()}_${Math.random()}`
          });
        });

        console.log(this.rows);

        if (duplicateCount > 0) {
          this.error(`${duplicateCount} baris duplikat dilewati.`);
        }
      } finally {
        this.isLoading = false;
      }
    },
    onSelectionChanged(params) {
      this.selectedRows = params.selectedRows || [];
    },
    handleDeleteRows() {
      console.log(this.selectedRows);

      if (!this.selectedRows.length) return;

      const selectedIds = new Set(this.selectedRows.map(item => item._uniqueId).filter(Boolean));

      this.rows = this.rows.filter(item => !selectedIds.has(item._uniqueId));
      this.selectedRows = [];

      if (typeof this.$refs.detailTable?.unselectAllInternal === "function") {
        this.$refs.detailTable.unselectAllInternal();
      }

      this.success("Baris yang dipilih berhasil dihapus.");
    },
    resetForm() {
      const currentPiNumber = this.isEdit ? this.form.pi_no : "";
      const currentLoadId = this.isEdit ? this.form.load_id : "";
      const currentHeaderId = this.isEdit ? this.form.proforma_invoice_header_id : "";

      this.form = {
        ...buildEmptyForm(),
        ...(this.isEdit
          ? {
            pi_no: currentPiNumber,
            load_id: currentLoadId,
            proforma_invoice_header_id: currentHeaderId,
          }
          : {}),
      };
      this.selectedTemplate = null;
      this.templateFields = [];
      this.templateDetails = [];
      this.activeTabIndex = 0;
      this.monthPeriodeDate = null;
      this.samForm = {
        piRental: null,
        billableMethod: null,
        dateRange: {
          startDate: null,
          endDate: null,
        },
      };
      this.rows = [];
      this.selectedRows = [];
      this.companyGetLoad = null;
      this.nstRulesOptions = [];
      this.selectedPpn = null;
      this.checkedLoadId = "";
      this.isCheckingLoad = false;
      this.isLoadChecked = false;
      this.templateSelectKey += 1;
      this.tableRenderKey += 1;

      if (typeof this.$refs.detailTable?.unselectAllInternal === "function") {
        this.$refs.detailTable.unselectAllInternal();
      }
    },
    isCurrencyField(field) {
      return CURRENCY_FIELDS.has(field);
    },
    getRowClass(row) {
      return row?._isGroupTotal ? 'amn-group-total-row' : '';
    },
    formatCell(value) {
      if (value === null || value === undefined || value === "") {
        return "-";
      }

      return value;
    },
    formatNumber(value) {
      const numericValue = Math.round(Number(value || 0));
      return numericValue.toLocaleString("id-ID", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
    },
    buildSubmitPayload() {
      const dppAmount = this.summaryDpp;
      const taxType = this.selectedPpn || "";
      const taxAmount = this.summaryPpn;

      const rows = this.rows
        // Baris Total AMN (_isGroupTotal) hanya untuk tampilan, tidak dikirim ke BE
        .filter((item) => !item._isGroupTotal)
        .map((item) => {
          const payload = { ...item };

          payload.proforma_invoice_template_detail_id =
            item._sheetDetailId || item.proforma_invoice_template_detail_id || null;

          delete payload.vgt_id;
          delete payload.originalIndex;
          delete payload._uniqueId;
          delete payload._isGroupTotal;
          delete payload._isPartOfSplitGroup;
          delete payload._sheetDetailId;

          // Tambahkan field perhitungan PPN ke setiap row
          payload.dpp_amount = dppAmount;
          payload.tax_type = taxType;
          payload.tax_amount = taxAmount;

          return payload;
        });

      return {
        customer_id: this.customer.company_code,
        pi_type: this.form.pi_type,
        customer_name: this.customer.customer_name,
        proforma_invoice_template_header_id: String(
          this.form.proforma_invoice_template_header_id
        ),
        total_charge: this.summaryTotalCharge,
        month_periode: this.formatDateToIndonesianMonth(this.monthPeriodeDate),
        ...(this.isEdit ? { pi_no: this.form.pi_no } : {}),
        ...(this.isSam
          ? {
              pi_rental_id:
                this.samForm.piRental?.id ||
                this.samForm.piRental?.pi_rental_id ||
                null,
              billable_method_id:
                this.samForm.billableMethod?.rm_billable_tariff_id || null,
              billable_method_name:
                this.samForm.billableMethod?.tariff_name || null,
              date_from: this.samForm.dateRange?.startDate
                ? this.$moment(this.samForm.dateRange.startDate).format("YYYY-MM-DD")
                : null,
              date_to: this.samForm.dateRange?.endDate
                ? this.$moment(this.samForm.dateRange.endDate).format("YYYY-MM-DD")
                : null,
            }
          : {}),
        rows,
      };
    },
    async submitForm() {
      if (!this.canSubmit) {
        this.error("Lengkapi header dan detail PI terlebih dahulu.");
        return;
      }

      const result = await this.$swal({
        title: this.isEdit ? "Update Proforma Invoice?" : "Kirim Proforma Invoice?",
        text: this.isEdit
          ? "Perubahan data PI akan disimpan."
          : "Data PI akan dikirim ke backend.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya, lanjutkan",
        cancelButtonText: "Batalkan",
      });

      if (!result.value) {
        return;
      }

      const payload = this.buildSubmitPayload();
      let baseURI =
        `${this.proformaInvoiceEndpoint}v1/company-list/create-proforma-invoice`;



      this.isLoading = true;

      if (this.isEdit) {
        console.log(payload);
        baseURI = `${this.proformaInvoiceEndpoint}v1/company-list/update-proforma-invoice`;
        try {
          const response = await this.$http.patch(baseURI, payload);
          if (response.data?.status === 200) {
            this.success(
              this.isEdit ? "Proforma invoice berhasil diperbarui." : "Proforma invoice berhasil dibuat."
            );
            this.goBack();
            return;
          }

          this.error(response.data?.message || "Gagal menyimpan proforma invoice.");
        } catch (error) {
          this.handleRequestError(error, "Gagal menyimpan proforma invoice.");
        } finally {
          this.isLoading = false;
        }
      } else {
        try {
          const response = await this.$http.post(baseURI, payload);

          if (response.data?.status === 200) {
            this.success(
              "Preforma invoice berhasil dibuat."
            );
            this.goBack();
            return;
          }

          this.error(response.data?.message || "Gagal menyimpan proforma invoice.");
        } catch (error) {
          this.handleRequestError(error, "Gagal menyimpan proforma invoice.");
        } finally {
          this.isLoading = false;
        }
      }
    },

    async loadEditData() {
      this.isLoading = true;

      try {
        const response = await this.$http.get(
          `${this.proformaInvoiceEndpoint}v1/company-list/get-detail-pi`,
          {
            params: {
              company_code: this.$route.params.id,
              pi_no: this.$route.params.piNo,
            },
          }
        );

        const header = response.data?.header || {};
        const detailRows = Array.isArray(response.data?.detail)
          ? response.data.detail
          : [];
        const template = header.template || {};
        const fallbackLoadId = [
          ...new Set(
            detailRows.map((item) => String(item?.load_id || "")).filter(Boolean)
          ),
        ].join(",");
        const fallbackShipmentNo = [
          ...new Set(
            detailRows
              .map((item) => String(item?.shipment_no || ""))
              .filter(Boolean)
          ),
        ].join(",");
        const fallbackPiType = detailRows.find((item) => item?.pi_type)?.pi_type || "";

        this.customer = {
          company_code: header.customer_id || this.customer.company_code || "",
          customer_name: header.customer_name || this.customer.customer_name || "",
          sap_code: header.company?.sap_code || this.customer.sap_code || "",
        };
        this.checkedLoadId = header.load_id || fallbackLoadId;
        const rawMonth = header.month_periode || header.report_period || "";
        this.monthPeriodeDate = this.parseMonthPeriodeToDate(rawMonth);
        this.form = {
          load_id: (!this.isView) ? "" : (header.load_id || fallbackLoadId),
          shipment_no: (!this.isView) ? "" : (header.shipment_no || fallbackShipmentNo),
          pi_type: header.pi_type || fallbackPiType,
          pi_no: header.pi_no || this.$route.params.piNo || "",
          proforma_invoice_template_header_id: String(
            header.proforma_invoice_template_header_id || template.proforma_invoice_template_header_id || template.id || ""
          ),
          proforma_invoice_header_id: header.proforma_invoice_header_id || header.id || "",
          month_periode: this.formatDateToIndonesianMonth(this.monthPeriodeDate) || "",
        };
        if (template.proforma_invoice_template_header_id) {
          this.selectedTemplate = {
            proforma_invoice_template_header_id:
              template.proforma_invoice_template_header_id,
            template_name: template.template_name || "-",
            description: template.description || "",
          };
          this.templateOptions = [
            this.selectedTemplate,
            ...this.templateOptions.filter(
              (item) =>
                String(item.proforma_invoice_template_header_id) !==
                String(template.proforma_invoice_template_header_id)
            ),
          ];
          this.templateFields = this.normalizeTemplateFields(template.detail || []);
          // Restore raw templateDetails untuk tabs
          this.templateDetails = [...(template.detail || [])].sort(
            (a, b) => (a.detail_order || 0) - (b.detail_order || 0)
          );
          this.activeTabIndex = 0;
        }

        // Untuk AMN: reconstruct baris tampilan dari data tersimpan
        if (this.isAmn) {
          const amnRows = this.buildAmnRowsFromSaved(detailRows);
          this.rows = amnRows.map((item, index) => ({
            ...item,
            // Gunakan proforma_invoice_template_detail_id dari item jika ada,
            // fallback ke detail pertama dari template
            _sheetDetailId: item.proforma_invoice_template_detail_id ||
              this.templateDetails[0]?.proforma_invoice_template_detail_id || null,
            _uniqueId: `edit_amn_${index}_${Date.now()}_${Math.random()}`,
          }));
        } else {
          this.rows = detailRows.map((item, index) => ({
            ...item,
            rate: Number(item.rate || 0),
            _sheetDetailId: item.proforma_invoice_template_detail_id ||
              this.templateDetails[0]?.proforma_invoice_template_detail_id || null,
            _uniqueId: `edit_${index}_${Date.now()}_${Math.random()}`
          }));
        }
        this.initialRowsCount = this.rows.length;

        // Cek sekali apakah API mengembalikan field charge per baris
        // Digunakan oleh summaryTotalCharge untuk memilih mode kalkulasi
        this.hasRowChargeData = this.rows.some(item =>
          CHARGE_FIELDS.some(field => Number(item[field] || 0) > 0)
        );

        if (this.isSam) {
          if (header.billable_method_id || header.billable_method_name) {
            this.samForm.billableMethod = {
              rm_billable_tariff_id: header.billable_method_id,
              tariff_name: header.billable_method_name || "",
            };
            this.billableTariffOptions = [this.samForm.billableMethod];
          }
          if (header.pi_rental_id || header.pi_rental_name) {
            this.samForm.piRental = {
              id: header.pi_rental_id,
              rental_name: header.pi_rental_name || "",
            };
            this.piRentalOptions = [this.samForm.piRental];
          }
          if (header.date_from || header.date_to) {
            this.samForm.dateRange = {
              startDate: header.date_from ? new Date(header.date_from) : null,
              endDate: header.date_to ? new Date(header.date_to) : null,
            };
          }
        }

        if (
          this.form.pi_type &&
          !this.piTypeOptions.some((item) => item.value === this.form.pi_type)
        ) {
          this.piTypeOptions = [
            {
              value: this.form.pi_type,
              label: this.form.pi_type,
            },
            ...this.piTypeOptions,
          ];
        }
        console.log(header.tax_type);
        if (header.tax_type) {
          this.nstRulesOptions = [header.tax_type];
          this.selectedPpn = header.tax_type;
        }
        console.log(this.selectedPpn)
        this.headerDpp = Number(header.dpp_amount || 0);
        this.headerPpn = Number(header.tax_amount || 0);
        this.headerRate = Number(header.rate || header.rate_amount || 0);
        this.headerTotalRate = Number(header.total_rate || header.total_amount || 0);
        this.headerTotalCharge = Number(header.total_charge || 0);
      } catch (error) {
        this.handleRequestError(error, "Gagal load detail PI.");
      } finally {
        this.isLoading = false;
      }
    },
    async loadBillableTariff() {
      try {
        const response = await this.$http.get(
          `${this.$settings.endPoint}rm-billable-tariff?customer_code=${this.customer.company_code}&status=ENABLED`
        );
        const datas = response.data?.datas?.data || response.data?.datas || [];
        this.billableTariffOptions = Array.isArray(datas) ? datas : [];
      } catch (error) {
        this.billableTariffOptions = [];
      }
    },
    async searchBillableTariff(query) {
      if (!query) {
        return this.loadBillableTariff();
      }
      try {
        const response = await this.$http.get(
          `${this.$settings.endPoint}rm-billable-tariff?customer_code=${this.customer.company_code}&tariff_name=${query}&status=ENABLED`
        );
        const datas = response.data?.datas?.data || response.data?.datas || [];
        this.billableTariffOptions = Array.isArray(datas) ? datas : [];
      } catch (error) {
        this.billableTariffOptions = [];
      }
    },
    async loadPiRental() {
      try {
        const response = await this.$http.get(
          `${this.proformaInvoiceEndpoint}v1/pi-rental?customer_code=${this.customer.company_code}`
        );
        const datas = response.data?.datas?.data || response.data?.datas || [];
        this.piRentalOptions = Array.isArray(datas) ? datas : [];
      } catch (error) {
        this.piRentalOptions = [];
      }
    },
    async searchPiRental(query) {
      if (!query) {
        return this.loadPiRental();
      }
      try {
        const response = await this.$http.get(
          `${this.proformaInvoiceEndpoint}v1/pi-rental?customer_code=${this.customer.company_code}&q=${query}`
        );
        const datas = response.data?.datas?.data || response.data?.datas || [];
        this.piRentalOptions = Array.isArray(datas) ? datas : [];
      } catch (error) {
        this.piRentalOptions = [];
      }
    },
    goBack() {
      this.$router.push({
        name: "CustomerListDetail",
        params: {
          id: this.customer.company_code || this.$route.params.id,
        },
        query: {
          name: this.customer.customer_name || "",
          sap_code: this.customer.sap_code || "",
        },
      });
    },
    handleRequestError(error, fallbackMessage) {
      if (error?.response?.status === 500) {
        this.$router.push("/server-error");
        return;
      }

      if (error?.response?.status === 404) {
        this.$router.push("/page-not-found");
        return;
      }

      const message =
        error?.response?.data?.errors?.message ||
        error?.response?.data?.message ||
        fallbackMessage;

      this.error(message);
    },
    fetchIt() {
      const userDatas = this.$getUserInfo ? this.$getUserInfo() : null;

      if (!userDatas?.sub?.permision_role) {
        return;
      }

      let rolePermision = null;

      userDatas.sub.permision_role.forEach((permision) => {
        if (
          permision.permission.controller === "TemplatePIController" ||
          permision.permission.controller === "ProformaInvoiceController"
        ) {
          rolePermision = permision;
        }
      });

      if (rolePermision && !rolePermision.method_read) {
        this.$router.push("/authorized-error");
        return;
      }

      if (rolePermision) {
        this.permision_role = rolePermision;
      }
    },
    success(message) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });

      Toast.fire({
        icon: "success",
        title: message,
      });
    },
    error(message) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });

      Toast.fire({
        icon: "error",
        title: message,
      });
    },
    recalculate() {
      this.$swal({
        title: this.$t("areYouSure"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          this.$swal({
            icon: "warning",
            title: "Please Wait",
            text: "Don't Close This Page !!!",
            timerProgressBar: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            showCancelButton: false, // There won't be any cancel button
            showConfirmButton: false, // There won't be any confirm button
            didOpen: async () => {
              this.$swal.showLoading();

              const baseURI =
                this.proformaInvoiceEndpoint +
                "v1/company-list/recalculate-proforma-invoice";

              const payload = {
                company_code: this.customer.company_code || "",
                load_id: this.form.load_id || "",
                tax_type: this.selectedPpn || "",
                pi_no: this.form.pi_no || "",
                // auto_dpp: this.companyGetLoad?.company_setting?.auto_dpp || "N",
                proforma_invoice_template_header_id: String(
                  this.form.proforma_invoice_template_header_id
                ),
              };

              await this.$http
                .post(baseURI, payload)
                .then(() => {
                  this.loadEditData();
                  this.$swal.close();
                  this.success("Recalculate success");
                })
                .catch((error) => {
                  this.$swal.close();
                  this.handleRequestError(error, "Gagal melakukan recalculate.");
                });
            },
          });
        }
      });
    },
  },
  async mounted() {
    this.fetchIt();
    await this.initializePage();
  },
};
</script>

<style scoped>
.customer-pi-card {
  border: 1px solid #dfe3ea;
}

.status-title {
  color: #202124;
  font-size: 1.75rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
}

.summary-card {
  border: 1px solid #dfe3ea;
  border-radius: 0.5rem;
  padding: 1rem;
}

.summary-row {
  align-items: center;
  display: grid;
  gap: 0.75rem;
  grid-template-columns: 100px 1fr;
  margin-bottom: 0.75rem;
}

.template-option {
  display: flex;
  flex-direction: column;
}

@media (max-width: 991px) {
  .status-title {
    font-size: 1.4rem;
  }
}

/* AMN grouping – baris Total */
.amn-group-total-row {
  background-color: #eef2ff !important;
}

.amn-total-value {
  font-weight: 700;
  color: #1e40af;
}

/* ── Tabs dinamis (sheet template) ────────────────────────── */
.pi-tabs-wrapper {
  border-bottom: 2px solid #dee2e6;
}

.pi-sheet-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 0;
  list-style: none;
  margin: 0;
  padding: 0;
}

.pi-sheet-tabs .nav-item {
  margin-bottom: -2px;
}

.pi-sheet-tabs .nav-link {
  background: none;
  border: 1px solid transparent;
  border-radius: 0.375rem 0.375rem 0 0;
  color: #6c757d;
  cursor: pointer;
  display: block;
  min-width: 110px;
  padding: 0.5rem 1rem 0.45rem;
  text-align: center;
  transition: color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease;
}

.pi-sheet-tabs .nav-link:hover {
  background-color: #f8f9fa;
  border-color: #dee2e6 #dee2e6 transparent;
  color: #495057;
}

.pi-sheet-tabs .nav-link.active {
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff;
  color: #0d6efd;
  font-weight: 600;
}

.tab-alias {
  color: #9ca3af;
  font-size: 0.68rem;
  line-height: 1.2;
  margin-top: 1px;
}
</style>
